import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { User } from "@core/models";
import {
  Fares,
  MultifamilyRS,
  SeatAvailSegment,
  Segment,
  TransportSupplement,
} from "@core/models/flight-llego";
import {
  FlightLleegoService,
  NgxToastrService,
  StateService,
  UserService,
  UtilsService,
} from "@core/services";
import { TranslateService } from "@ngx-translate/core";
import airports from "assets/utils/airports.json";
import moment from "moment";
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: "app-flight-step-detail",
  templateUrl: "./flight-step-detail.component.html",
  styleUrls: ["./flight-step-detail.component.scss"],
  animations: [
    trigger('accordion', [
      state(
        'open',
        style({
          height: '*',
          opacity: 1,
          overflow: 'hidden',
        })
      ),
      state(
        'closed',
        style({
          height: '0px',
          opacity: 0,
          overflow: 'hidden',
        })
      ),
      transition('closed => open', [animate('300ms ease-out')]),
      transition('open => closed', [animate('300ms ease-in')]),
    ]),
  ],
})
export class FlightStepDetailComponent implements OnInit, AfterViewInit {
  @Input() loadingFlight: Boolean;
  @Input() selectedFlights: Segment[][];
  @Input() fareSelected?: Fares;
  @Input() totalPrice: number;
  basePrice = 0;
  @Input() fareName: string;
  canBaggage = false;
  @Input() requestData?: any;
  @Input() multiFamily: MultifamilyRS;
  @Input() totalFlightDuration: any;
  baggagesInfo: TransportSupplement[];
  baggageCodes = [
    "SSR_ABAG",
    "SSR_ASVC",
    "SSR_BBAG",
    "SSR_CBAG",
    "CKIN",
    "SSR_DBAG",
    "EXBG",
    "SSR_FBAG",
    "SSR_HBAG",
    "LGXB",
    "MEXB",
    "SSR_OBAG",
    "SSR_PDBG",
    "SSR_SBAG",
    "SMXB",
    "SNBG",
    "SSR_XABG",
    "SSR_XBAG",
    "XBAA",
    "XBAB",
    "XBAS",
    "XBAT",
    "XLXB",
    "XLSW",
    "XTSI",
  ];
  @Output() baggageSelectedEvent = new EventEmitter<any>();
  @Output() seatMapEvent = new EventEmitter<any>();
  selectedBags: any[] = [];
  multipleSelectedBags: { [passengerId: string]: { [segmentId: string]: any[] } } = {};
  bagSelected: any;
  seeHangover: boolean[] = [false, false];
  needDocApis: boolean;
  needAddress: boolean;
  emitOnBookingDetail: any;
  availablePayments: any;
  farePricing: any;
  selectedBaggages: TransportSupplement[] = [];
  @Output() changeFare: EventEmitter<any> = new EventEmitter<any>();
  @Output() nextStep: EventEmitter<any> = new EventEmitter<any>();
  @Input() durations: any[];
  originName: string;
  departureName: string;
  currentSegment: SeatAvailSegment;
  user: User;
  canUseResident: boolean;
  @Input() userFilters?: any;
  allowMultipleBags: boolean = true;
  @Input() selectedUsers: any;
  @Input() company: any;
  @Input() isEmployee: boolean;
  @Input() journeysAssociations: any;
  isBaggageExpanded: boolean = false;
  isPassengerExpanded: boolean[] = [];
  maxBaggagePerPassenger: number | null = null;
  justOneBaggage: boolean;
  pricing: any;
  accomInfo;
  priorityInfo: TransportSupplement[] = [];
  canPriority = false;
  justOnePriority = false;
  multipleSelectedPriority: { [passengerUuid: string]: { [segmentId: string]: any[] } } = {};
  selectedPriority: any[] = [];
  isPriorityExpanded = false;
  isPriorityPassengerExpanded: boolean[] = [];
  @Output() prioritySelectedEvent = new EventEmitter<any>();
  passengerBookingParams: any = null;
  includedBaggages: TransportSupplement[] = [];

  constructor(
    public translate: TranslateService,
    private flightLleegoService: FlightLleegoService,
    private utilsService: UtilsService,
    private ngxToastrService: NgxToastrService,
    private router: Router,
    private userService: UserService,
    private stateService: StateService,
  ) {
    const accom = localStorage.getItem('packageRateAccomInfo')
    if (accom) {
      this.accomInfo = JSON.parse(accom)
    }
  }

  ngOnInit(): void {
    this.isPassengerExpanded = Array(this.selectedUsers.length).fill(false);
    this.isPriorityPassengerExpanded = Array(this.selectedUsers.length).fill(false);
    this.utilsService.loadingFlights = true;
    this.userService
      .getUser(this.requestData.userUuid)
      .subscribe((res: User) => {
        this.user = res;
        this.canUseResident = this.user.resident && this.user.resident.toString() !== "none" && this.stateService.residentCandidates && this.stateService.residentCandidates.find(r => r === this.user.resident);
        let params = {
          token: this.requestData.token,
          userUuid: this.requestData.userUuid,
          passengers: this.requestData.passengers,
        };
        if (
          this.fareSelected &&
          this.multiFamily &&
          this.multiFamily.fares.length > 0
        ) {
          params["solutionID0"] = this.fareSelected.id;
          params["journey00"] = this.fareSelected.journeys_ids[0];
          params["journey01"] =
            this.fareSelected.journeys_ids[
              this.fareSelected.journeys_ids.length - 1
            ];
        } else {
          params["solutionID0"] = this.requestData.solutionID0;
          params["journey00"] = this.requestData.journey00;
          params["journey01"] = this.requestData.journey01;
        }
        if (this.canUseResident) {
          params["resident"] = this.user.resident;
        }
        this.flightLleegoService.getFlightPricing(params).subscribe(
          (res) => {
            this.pricing = res.price
            this.passengerBookingParams =
              res?.solutions?.[0]?.transport?.parameters_booking?.find(
                (param) => param?.context === "pax" && param?.type === "passenger"
              ) ?? null;
            this.selectedFlights = this.selectedFlights.map((flightSegment) => {
              return flightSegment.map(segment => { 
                const allSegments = res.solutions[0].transport.origin_destinations
                  .reduce((acc, od) => acc.concat(od.journeys || []), [])
                  .reduce((acc, journey) => acc.concat(journey.segments || []), []);
            
                const segmentFlightNumber = segment.object.transport_number.replace(/\D/g, "");
                const matchingSegment = allSegments.find(seg => seg.nv.includes(segmentFlightNumber));
            
                return {
                  ...segment,
                  object: {
                    ...segment.object,
                    cabin: matchingSegment ? matchingSegment.cabin : "N/A"
                  }
                };
              });
            });
            this.availablePayments = this.normalizePayments(res.available_payments);
            if (res.solutions[0].transport.catalogue) {
              delete params.passengers;
              delete params["resident"];
              if (this.canUseResident) {
                this.stateService.transportId = res.solutions[0].transport.id;
                params["solutionID0"] = res.solutions[0].transport.id;
              }
              this.seatMapEvent.emit({ params })
              this.flightLleegoService
                .getFlightStandalonecatalogue(params, "baggages")
                .subscribe(
                  (resBaggages) => {
                    if (resBaggages.solutions[0]?.rules?.SportBaggage?.maxQuantityAllowedByPassenger) {
                      this.maxBaggagePerPassenger = parseInt(resBaggages.solutions[0]?.rules?.SportBaggage?.maxQuantityAllowedByPassenger, 10);
                    } else {
                      this.maxBaggagePerPassenger = null;
                    }
                    this.utilsService.loadingFlights = false;
                    if (
                      resBaggages.solutions[0] &&
                      resBaggages.solutions[0]?.services &&
                      resBaggages.solutions[0]?.services.length > 0
                    ) {
                      if (resBaggages.solutions[0].selections.Baggage === "one") {
                        this.justOneBaggage = true;
                      }
                      const baggages = [];
                      const priority: any[] = [];

                      if (resBaggages.solutions[0]?.selections?.PriorityBoard) {
                        this.justOnePriority = resBaggages.solutions[0].selections.PriorityBoard !== "multiple";
                      }

                      resBaggages.solutions[0].services.forEach((service) => {
                        const cat = service.category?.toLowerCase();

                        if (cat === "baggage") {
                          this.changePassengerNames(resBaggages.solutions[0].paxes_types, service);
                          baggages.push(service);
                        }

                        if (cat === "priorityboard") {
                          this.changePassengerNames(resBaggages.solutions[0].paxes_types, service);
                          priority.push(service);
                        }
                      });
                      this.priorityInfo = priority;
                      this.canPriority = priority.length > 0;

                      if (baggages.length > 0) {
                        if (
                          this.selectedFlights.length > 1 &&
                          !(
                            this.fareSelected &&
                            this.multiFamily &&
                            this.multiFamily.fares.length > 0
                          )
                        ) {
                          const outwardBaggages = baggages.filter((bag) =>
                            bag.short_name?.toLowerCase().includes("outward")
                          );
                          const returnBaggages = baggages.filter((bag) =>
                            bag.short_name?.toLowerCase().includes("return")
                          );
                          this.baggagesInfo = [
                            ...outwardBaggages,
                            ...returnBaggages,
                          ];
                        } else {
                          this.baggagesInfo = baggages;
                        }
                        this.canBaggage = true;
                        this.loadingFlight = false;
                      }
                    } else {
                      this.translate
                        .get("flight.form-flight.error")
                        .subscribe((resp) => {
                          this.utilsService.loadingFlights = false;
                          this.canBaggage = false;
                        });
                    }
                  },
                  (err) => {
                    this.translate
                      .get("flight.form-flight.error")
                      .subscribe((resp) => {
                        this.utilsService.loadingFlights = false;
                        this.canBaggage = false;
                      });
                  }
                );
            }
            this.totalPrice = res.price.total * 1;
            this.stateService.totalPrice = this.totalPrice;
            this.needDocApis = res.solutions[0].need_doc_apis;
            this.needAddress = res.solutions[0].need_address;
            this.emitOnBookingDetail =
              res.solutions[0].transport.emit_on_booking_detail;
            this.canBaggage = res.solutions[0].transport.catalogue;
            if (!this.canBaggage) {
              this.utilsService.loadingFlights = false;
            }
            if (
              this.fareSelected &&
              this.multiFamily &&
              this.multiFamily.fares.length > 0
            ) {
              this.bagSelected;
            }
            this.farePricing = {
              amount: res.price.amount,
              total: res.price.total,
              base: res.price.base,
              taxes: Math.round(res.price.total_taxes),
            };
            this.includedBaggages = this.buildIncludedBaggages();
            this.emitAllBaggages();
          },
          (err) => {
            this.utilsService.loadingFlights = false;
            this.translate.get("flight.form-flight.error").subscribe((resp) => {
              this.loadingFlight = false;
              this.utilsService.loadingFlights = false;
              this.ngxToastrService.typeInfo(resp, "");
              this.router.navigate(['/flight'], { queryParams: { didSearch: true } });
            });
          }
        );
      });

    this.loadingFlight = false;
  }

  normalizePayments(input) {
    if (!Array.isArray(input)) return [];
  
    if (input.length === 1 && Array.isArray(input[0])) {
      return this.normalizePayments(input[0]);
    }
  
    return input.map(item => {
      if (
        item &&
        typeof item === 'object' &&
        !Array.isArray(item) &&
        Object.keys(item).length === 1
      ) {
        const value = Object.values(item)[0];
        if (
          value &&
          typeof value === 'object' &&
          'id' in value &&
          'name' in value
        ) {
          return value;
        }
      }
  
      return item;
    });
  }

  changePassengerNames(paxes_types: any, transportSup: any) {
    const passengerNames = Object.keys(paxes_types);
    transportSup.pax_index = transportSup.pax_references.map(name => passengerNames.indexOf(name)).filter(index => index !== -1);
  }

  ngAfterViewInit(): void {}

  getLogo(value) {
    return `assets/img/airlines/small/${value}.png`;
  }

  updateBaggagePrice(event: any) {
    this.totalPrice = this.basePrice;
    for (const foundBaggage of event) {
      this.totalPrice += foundBaggage.total;
    }
    this.selectedBaggages = event;
  }

  toggleHanover(index: number) {
    this.seeHangover[index] = !this.seeHangover[index];
  }

  calcTotalSegmentTime(segmentArr: Segment[]): string {
    let totalTime;
    const departDatetime = moment(
      segmentArr[0].object.departure_date,
      moment.ISO_8601
    );
    const returnDatetime = moment(
      segmentArr[segmentArr.length - 1].object.arrival_date,
      moment.ISO_8601
    );
    const duration = moment.duration(returnDatetime.diff(departDatetime));
    const days = duration.days();
    const hours = duration.hours();
    const hoursFormatted = `${hours}h `;
    const minutes = duration.minutes();
    const minutesFormatted = `${minutes}m`;
    totalTime = `${hoursFormatted}${minutesFormatted}`;
    if (days > 0) {
      const daysFormatted = `${days}d `;
      totalTime = `${daysFormatted}${totalTime}`;
    }
    return totalTime;
  }

  calcPartialSegmentTime(segment: Segment): string {
    let totalTime;
    const departDatetime = moment(
      segment.object.departure_date,
      moment.ISO_8601
    );
    const returnDatetime = moment(segment.object.arrival_date, moment.ISO_8601);
    const duration = moment.duration(returnDatetime.diff(departDatetime));
    const hours = duration.hours();
    const hoursFormatted = `${hours}h `;
    const minutes = duration.minutes();
    const minutesFormatted = `${minutes}m`;
    totalTime = `${hoursFormatted} ${minutesFormatted}`;
    return totalTime;
  }

  getStops(segmentArr: Segment[]): Segment[] {
    const segmentArrCopy = [...segmentArr];
    segmentArrCopy.splice(0, 1);
    return segmentArrCopy;
  }

  emitChangeFare() {
    this.changeFare.emit();
  }

  getBaggageOptions(segmentArr: Segment[]): TransportSupplement[] {
    const segmentIds = segmentArr.map((segment) => segment.id);
    const baggageOptions = this.baggagesInfo.filter((service) => {
      return segmentIds.every(function (element) {
        return service.seg_references.includes(element);
      });
    });
    return baggageOptions;
  }

  selectBaggage(baggageInfoIndex: number, baggage?: any) {
    if (baggage !== -1) {
      if (baggageInfoIndex === 1 && this.selectedBags[0] == null) {
        this.selectedBags[0] = { total: 0 };
      }
      this.selectedBags[baggageInfoIndex] = baggage;
    } else {
      this.selectedBags[baggageInfoIndex] = { total: 0 };
    }
    this.emitAllBaggages();
  }

  getPrice(): number {
    let price = Math.round(this.farePricing.total * 100) / 100;

    if (this.selectedBags?.length > 0) {
      for (const baggage of this.selectedBags) {
        if (baggage?.total) {
          const passengerCount =
            Array.isArray(baggage?.pax_index) ? baggage.pax_index.length :
            Array.isArray(baggage?.pax_references) ? baggage.pax_references.length :
            1;

          price += Math.round(Number(baggage.total) * passengerCount * 100) / 100;
        }
      }
    }

    if (this.selectedPriority?.length > 0) {
      for (const prio of this.selectedPriority) {
        if (prio?.total) {
          const passengerCount =
            Array.isArray(prio?.pax_index) ? prio.pax_index.length :
            Array.isArray(prio?.pax_references) ? prio.pax_references.length :
            1;

          price += Math.round(Number(prio.total) * passengerCount * 100) / 100;
        }
      }
    }

    return price;
  }

  getTotalBaggagePrice(): number {
    if (!this.selectedBags || this.selectedBags.length === 0) {
      return 0;
    }
    return this.selectedBags.reduce((sum, baggage) => {
      const passengerCount =
        Array.isArray(baggage?.pax_index) ? baggage.pax_index.length :
        Array.isArray(baggage?.pax_references) ? baggage.pax_references.length :
        1;
      return sum + (baggage.total * passengerCount);
    }, 0);
  }

  baggageSelected(event, index) {
    if (event.value !== 0) {
      if (index === 1 && this.selectedBags[0] == null) {
        this.selectedBags[0] = { total: 0 };
      }
      this.selectedBags[index] = event.value;
    } else {
      this.selectedBags[index] = { total: 0 };
    }
    this.emitAllBaggages();
  }

  goNextStep() {
    const nextEmit = {
      needAddress: this.needAddress ? this.needAddress : false,
      needDocApis: this.needDocApis ? this.needDocApis : false,
      emitOnBookingDetail: this.emitOnBookingDetail
        ? this.emitOnBookingDetail
        : {},
      availablePayments: this.availablePayments ? this.availablePayments : {},
      totalPrice: this.canUseResident ? this.totalPrice : (this.pricing ? this.getPrice() : this.totalPrice),
      selectBaggage: [...(this.selectedBags ?? []), ...(this.includedBaggages ?? [])],
      selectPriority: this.selectedPriority ?? [],
      farePricing: this.farePricing ?? null,
      getPrice: this.getPrice(),
      pricing: this.pricing,
      passengerBookingParams: this.passengerBookingParams
    };
    if (this.needAddress || this.needDocApis || this.emitOnBookingDetail) {
      this.nextStep.emit(nextEmit);
    } else {
      this.nextStep.emit(nextEmit);
    }
  }

  getBaggagesInfo(
    segmentArr: any[] | any[][],
    type: 'outward' | 'return' | 'both' = 'outward',
    passengerIndex: number
  ): TransportSupplement[] {
    if (!this.baggagesInfo || !segmentArr || segmentArr.length === 0) {
      return [];
    }
  
    let filtered: TransportSupplement[];
  
    if (type === 'outward') {
      const firstSegment = Array.isArray(segmentArr[0]) ? segmentArr[0][0] : segmentArr[0];
      filtered = this.baggagesInfo.filter(
        (bag) =>
          bag.journey_references.some((ref: string) => ref.split("@").some((part) => firstSegment?.id.includes(part))) &&
          (bag.distribution === 'ByPassengerJourney' || bag.distribution === 'ByPassengerSegment') &&
          bag.pax_index.includes(passengerIndex)
      );
    } else if (type === 'return') {
      const lastSegment = Array.isArray(segmentArr[0])
        ? segmentArr[1][segmentArr[1].length - 1]
        : segmentArr[segmentArr.length - 1];
      filtered = this.baggagesInfo.filter(
        (bag) =>
          bag.journey_references.some((ref: string) => ref.split("@").some((part) => lastSegment?.id.includes(part))) &&
          (bag.distribution === 'ByPassengerJourney' || bag.distribution === 'ByPassengerSegment') &&
          bag.pax_index.includes(passengerIndex)
      );
    } else if (type === 'both') {
      const allSegmentIds = Array.isArray(segmentArr[0])
        ? segmentArr
            .map((segments: any[]) => segments.map((segment) => segment.id))
            .reduce((acc, curr) => acc.concat(curr), [])
        : segmentArr.map((segment) => segment.id);
  
      filtered = this.baggagesInfo.filter(
        (bag) =>
          Array.isArray(bag.journey_references) &&
          bag.journey_references.some((ref: string) => ref.split("@").some((part) => allSegmentIds.includes(part))) &&
          bag.distribution === 'ByPassenger' &&
          bag.pax_index.includes(passengerIndex)
      );
      return this.filterBaggages(filtered)
    } else {
      filtered = [];
    }
  
    return filtered;
  }
  
  filterBaggages(baggages: any[]): any[] {
    return baggages.reduce((acc: any[], bag) => {
      if (bag.distribution !== "ByPassenger") {
        acc.push(bag);
        return acc;
      }
      const exist = acc.some(m => m.distribution === "ByPassenger" && m.short_name === bag.short_name && m.source_i_d === bag.source_i_d);
      if (!exist) {
        acc.push(bag);
      }
      return acc;
    }, []);
  }

  getIncludesFare(service: string, journey: number) {
    let services = this.fareSelected?.services?.find((s) => s.category === service);
    switch (services?.journeys[journey]) {
      case "INC":
        return service === "Baggage" ? "flight.detail-flight.includes-checked" : "flight.detail-flight.includes-cabin";
      case "NOF":
      case "CHA":
        return service === "Baggage" ? "flight.detail-flight.no-includes-checked" : "flight.detail-flight.no-includes-cabin";
      case "NIN":
      default:
        return "flight.multifamily.no-info";
    }
  }

  getBaggagesNumber() {
    let total = 0;
    this.selectedBags.forEach((b) => {
      total +=
        Array.isArray(b?.pax_index) ? b.pax_index.length :
        Array.isArray(b?.pax_references) ? b.pax_references.length :
        1;
    });
    return total;
  }

  isNumber(bag) {
    return !isNaN(bag.total.toFixed());
  }
  getNameAirport(iata: string) {
    let nameAirport = "";
    airports["Table1"].forEach((ai) => {
      if (ai["IATA"] === iata) {
        nameAirport = ai["city"];
      }
    });
    return nameAirport;
  }


  isBagSelectedMultiple(passengerId: string, segmentId: string, bag: any): boolean {
    if (segmentId === 'both') {
      const outwardSegment = this.selectedFlights[0][0]?.id;
      return (
        this.multipleSelectedBags[passengerId]?.[outwardSegment]?.some(
          (selectedBag) => selectedBag.id === bag.id
        ) || false
      );
    }
  
    return (
      this.multipleSelectedBags[passengerId]?.[segmentId]?.some(
        (selectedBag) => selectedBag.id === bag.id
      ) || false
    );
  }

  toggleBagSelectionMultiple(passengerId: string, segmentId: string, bag: any, isChecked: boolean): void {
    const paxId = this.selectedUsers[+passengerId]?.uuid;
    if (!paxId) return;

    const passengerIndex = Number(passengerId);
    if (isNaN(passengerIndex)) return;

    if (!this.multipleSelectedBags[paxId]) {
      this.multipleSelectedBags[paxId] = {};
    }

    const totalSelectedBagsForPassenger = Object.values(this.multipleSelectedBags[paxId])
      .reduce((acc, segmentBags) => acc.concat(segmentBags), [])
      .filter((b, index, self) => self.findIndex((bag) => bag.id === b.id) === index)
      .length;

    if (
      isChecked &&
      (
        (this.justOneBaggage && totalSelectedBagsForPassenger > 1) ||
        (this.maxBaggagePerPassenger !== null && totalSelectedBagsForPassenger > this.maxBaggagePerPassenger)
      )
    ) {
      this.translate.get("my-bookeds.flight.max-baggage").subscribe((result) => {
        this.ngxToastrService.typeInfo(null, result);
      });
      return;
    }

    const originalPaxReference = this.getOriginalPaxReference(bag, passengerIndex);

    if (segmentId === 'both') {
      const outwardSegment = this.selectedFlights[0][0]?.id;
      if (!outwardSegment) return;

      if (!this.multipleSelectedBags[paxId][outwardSegment]) {
        this.multipleSelectedBags[paxId][outwardSegment] = [];
      }

      if (isChecked) {
        if (!this.multipleSelectedBags[paxId][outwardSegment].some((selectedBag) => selectedBag.id === bag.id)) {
          const newBag = { ...bag };
          newBag.pax_index = [passengerIndex];
          newBag.pax_references = originalPaxReference ? [originalPaxReference] : [];
          this.multipleSelectedBags[paxId][outwardSegment].push(newBag);
        }
      } else {
        this.multipleSelectedBags[paxId][outwardSegment] =
          this.multipleSelectedBags[paxId][outwardSegment].filter((selectedBag) => selectedBag.id !== bag.id);
      }
    } else {
      if (!this.multipleSelectedBags[paxId][segmentId]) {
        this.multipleSelectedBags[paxId][segmentId] = [];
      }

      if (isChecked) {
        if (!this.multipleSelectedBags[paxId][segmentId].some((selectedBag) => selectedBag.id === bag.id)) {
          const newBag = { ...bag };
          newBag.pax_index = [passengerIndex];
          newBag.pax_references = originalPaxReference ? [originalPaxReference] : [];
          this.multipleSelectedBags[paxId][segmentId].push(newBag);
        }
      } else {
        this.multipleSelectedBags[paxId][segmentId] =
          this.multipleSelectedBags[paxId][segmentId].filter((selectedBag) => selectedBag.id !== bag.id);
      }
    }

    this.updateSelectedBags();
  }

  updateSelectedBags(): void {
    const flattened = Object.values(this.multipleSelectedBags)
      .reduce((acc: any[], segmentsObj: { [segmentId: string]: any[] }) => {
        const segmentArrays = Object.values(segmentsObj);
        return acc.concat(
          segmentArrays.reduce((a: any[], arr: any[]) => a.concat(arr), [])
        );
      }, []);

    const merged = flattened.reduce((acc, bag) => {
      const segKey =
        (Array.isArray(bag?.seg_references) && bag.seg_references[0]) ||
        (Array.isArray(bag?.journey_references) && bag.journey_references[0]) ||
        bag?.source_i_d ||
        '';

      const key = `${bag?.id || ''}@@${segKey}`;
      const existing = acc.find((b) => b.__mergeKey === key);

      const currentIdx = (Array.isArray(bag.pax_index) ? bag.pax_index : [bag.pax_index])
        .map((n) => Number(n))
        .filter((n) => !isNaN(n));

      const currentRefs = Array.isArray(bag.pax_references)
        ? bag.pax_references.map((r) => String(r))
        : [];

      if (existing) {
        const pairMap = new Map<number, string>();

        (Array.isArray(existing.pax_index) ? existing.pax_index : [])
          .forEach((idx: number, i: number) => {
            pairMap.set(Number(idx), existing.pax_references?.[i] != null ? String(existing.pax_references[i]) : '');
          });

        currentIdx.forEach((idx, i) => {
          pairMap.set(idx, currentRefs[i] ?? '');
        });

        const sortedIdx = Array.from(pairMap.keys()).sort((a, b) => a - b);
        existing.pax_index = sortedIdx;
        existing.pax_references = sortedIdx
          .map((idx) => pairMap.get(idx))
          .filter(Boolean);
      } else {
        acc.push({
          ...bag,
          __mergeKey: key,
          pax_index: [...currentIdx].sort((a, b) => a - b),
          pax_references: currentIdx
            .map((idx, i) => currentRefs[i] ?? '')
            .filter(Boolean),
        });
      }

      return acc;
    }, [] as any[]);

    this.selectedBags = merged.map(({ __mergeKey, ...bag }) => bag);
    this.emitAllBaggages();
    this.totalPrice = this.getPrice();
  }
  
  getMultipleBagsLabel(passengerId: string, segmentId: string): string {
    const selectedBags = this.multipleSelectedBags[passengerId]?.[segmentId] || [];
    if (Array.isArray(selectedBags) && selectedBags.length > 0) {
      return selectedBags.map((bag) => bag.short_name).join(", ");
    }
    return this.translate.instant("flight.detail-flight.baggageSelection");
  }
  
  toggleBaggageContainer(): void {
    this.isBaggageExpanded = !this.isBaggageExpanded;
  }

  togglePassenger(index: number): void {
    this.isPassengerExpanded = this.isPassengerExpanded.map((isExpanded, i) =>
      i === index ? !isExpanded : false
    );
  }

  needsAuthorizationDetail(): boolean {
    const price = Number(this.totalPrice) || 0;

    const {
      priceMinFlight,
      priceMaxFlight,
      onlyFlightAuthorization,
      allowAmountOverDuration
    } = this.userFilters || {};

    if (onlyFlightAuthorization) return true;

    const withinMin = priceMinFlight == null ? true : price >= priceMinFlight;
    const withinMax = priceMaxFlight == null ? true : price <= priceMaxFlight;
    const withinBaseRange = withinMin && withinMax;

    const overDurCfg = allowAmountOverDuration;
    const legMaxHours = Number(this.totalFlightDuration) || 0;

    const anyLegExceeds =
      overDurCfg?.duration != null &&
      overDurCfg?.amount != null &&
      legMaxHours >= Number(overDurCfg.duration);

    if (!withinBaseRange) {
      if (anyLegExceeds && price <= Number(overDurCfg?.amount ?? NaN)) {
        return false;
      }
      return true;
    }
    return false;
  }

  getPriorityInfo(
    segmentArr: any[] | any[][],
    type: "outward" | "return" = "outward",
    passengerIndex: number
  ): TransportSupplement[] {
    if (!this.priorityInfo || !segmentArr || segmentArr.length === 0) return [];

    let filtered: TransportSupplement[] = [];

    if (type === "outward") {
      const firstSegment = Array.isArray(segmentArr[0]) ? segmentArr[0][0] : segmentArr[0];
      filtered = this.priorityInfo.filter((p) =>
        p.journey_references?.some((ref: string) => ref.split("@").some((part) => firstSegment?.id.includes(part))) &&
        p.distribution === "ByPassengerSegment" &&
        p.pax_index?.includes(passengerIndex)
      );
    } else {
      const lastSegment = Array.isArray(segmentArr[0])
        ? segmentArr[1][segmentArr[1].length - 1]
        : segmentArr[segmentArr.length - 1];

      filtered = this.priorityInfo.filter((p) =>
        p.journey_references?.some((ref: string) => ref.split("@").some((part) => lastSegment?.id.includes(part))) &&
        p.distribution === "ByPassengerSegment" &&
        p.pax_index?.includes(passengerIndex)
      );
    }

    return filtered;
  }

  isPrioritySelectedMultiple(passengerUuid: string, segmentId: string, prio: any): boolean {
    return (
      this.multipleSelectedPriority[passengerUuid]?.[segmentId]?.some((p) => p.id === prio.id) || false
    );
  }

  togglePrioritySelectionMultiple(
    passengerIndex: number,
    segmentId: string,
    prio: any,
    isChecked: boolean
  ): void {
    if (!segmentId || !prio) return;

    const passengerUuid = this.selectedUsers?.[passengerIndex]?.uuid;
    if (!passengerUuid) return;

    if (Array.isArray(prio.pax_index) && !prio.pax_index.includes(passengerIndex)) {
      return;
    }

    if (!this.multipleSelectedPriority[passengerUuid]) {
      this.multipleSelectedPriority[passengerUuid] = {};
    }
    if (!this.multipleSelectedPriority[passengerUuid][segmentId]) {
      this.multipleSelectedPriority[passengerUuid][segmentId] = [];
    }

    if (isChecked && this.justOnePriority) {
      this.multipleSelectedPriority[passengerUuid][segmentId] = [];
    }

    if (isChecked) {
      if (!this.multipleSelectedPriority[passengerUuid][segmentId].some((p) => p.id === prio.id)) {
        const originalPaxReference = this.getOriginalPaxReference(prio, passengerIndex);

        const newPrio = { ...prio };
        newPrio.pax_index = [passengerIndex];
        newPrio.pax_references = originalPaxReference ? [originalPaxReference] : [];
        this.multipleSelectedPriority[passengerUuid][segmentId].push(newPrio);
      }
    }
    else {
      this.multipleSelectedPriority[passengerUuid][segmentId] =
        this.multipleSelectedPriority[passengerUuid][segmentId].filter((p) => p.id !== prio.id);
    }

    this.updateSelectedPriority();
  }

  updateSelectedPriority(): void {
    const flattened = Object.values(this.multipleSelectedPriority)
      .reduce((acc: any[], segmentsObj: { [segmentId: string]: any[] }) => {
        const segmentArrays = Object.values(segmentsObj);
        return acc.concat(
          segmentArrays.reduce((a: any[], arr: any[]) => a.concat(arr), [])
        );
      }, []);

    const merged = flattened.reduce((acc, prio) => {
      const existing = acc.find((p) => p.id === prio.id);

      const currentIdx = (Array.isArray(prio.pax_index) ? prio.pax_index : [prio.pax_index])
        .map((n) => Number(n));

      const currentRefs = Array.isArray(prio.pax_references)
        ? prio.pax_references.map((r) => String(r))
        : [];

      if (existing) {
        const existingIdx = Array.isArray(existing.pax_index)
          ? existing.pax_index.map((n) => Number(n))
          : [Number(existing.pax_index)];

        const existingRefs = Array.isArray(existing.pax_references)
          ? existing.pax_references.map((r) => String(r))
          : [];

        const pairMap = new Map<number, string>();

        existingIdx.forEach((idx, i) => {
          pairMap.set(idx, existingRefs[i]);
        });

        currentIdx.forEach((idx, i) => {
          pairMap.set(idx, currentRefs[i]);
        });

        const sortedIdx = Array.from(pairMap.keys()).sort((a, b) => a - b);

        existing.pax_index = sortedIdx;
        existing.pax_references = sortedIdx.map((idx) => pairMap.get(idx)).filter(Boolean);
      } else {
        const pairMap = new Map<number, string>();

        currentIdx.forEach((idx, i) => {
          pairMap.set(idx, currentRefs[i]);
        });

        const sortedIdx = Array.from(pairMap.keys()).sort((a, b) => a - b);

        acc.push({
          ...prio,
          pax_index: sortedIdx,
          pax_references: sortedIdx.map((idx) => pairMap.get(idx)).filter(Boolean),
        });
      }

      return acc;
    }, [] as any[]);

    this.selectedPriority = merged;
    this.prioritySelectedEvent.emit(this.selectedPriority);
    this.totalPrice = this.getPrice();
  }

  togglePriorityContainer(): void {
    this.isPriorityExpanded = !this.isPriorityExpanded;
  }

  togglePriorityPassenger(index: number): void {
    this.isPriorityPassengerExpanded = this.isPriorityPassengerExpanded.map((isExpanded, i) =>
      i === index ? !isExpanded : false
    );
  }

  getTotalPriorityPrice(): number {
    if (!this.selectedPriority || this.selectedPriority.length === 0) return 0;

    return this.selectedPriority.reduce((sum, prio) => {
      const passengerCount = prio?.pax_index ? prio.pax_index.length : 1;
      return sum + (Number(prio?.total || 0) * passengerCount);
    }, 0);
  }

  getPriorityNumber(): number {
    let total = 0;
    (this.selectedPriority || []).forEach((p) => {
      total += (p?.pax_index?.length || 1);
    });
    return total;
  }

  getTotalPriceAccom() {
    let totalPrice = 0;
    this.accomInfo.selectedRooms.forEach((room) => {
      room.rates.forEach((rate) => {
        totalPrice += rate.price && rate.price.totalPrice ? Number(rate.price.totalPrice.total) : Number(rate.totalWithPercentage);
      })
    })
    return totalPrice;
  }

  getTotalPackage() {
    return this.totalPrice + this.getTotalPriceAccom()
  }

  private getOriginalPaxReference(service: any, passengerIndex: number): string | null {
    if (!service) return null;

    const paxIndexes = Array.isArray(service.pax_index) ? service.pax_index : [];
    const paxReferences = Array.isArray(service.pax_references) ? service.pax_references : [];

    const idx = paxIndexes.findIndex((p) => Number(p) === Number(passengerIndex));

    if (idx === -1) return null;

    return paxReferences[idx] != null ? String(paxReferences[idx]) : null;
  }


  private buildIncludedBaggages(): TransportSupplement[] {
    if (
      !this.fareSelected ||
      !Array.isArray(this.fareSelected.services) ||
      !Array.isArray(this.selectedFlights) ||
      !Array.isArray(this.selectedUsers) ||
      !Array.isArray(this.journeysAssociations)
    ) {
      return [];
    }

    const baggageService = this.fareSelected.services.find(
      (s) => s?.category === "Baggage"
    );

    if (!baggageService || !Array.isArray(baggageService.journeys)) {
      return [];
    }

    const includedBags: any[] = [];

    this.selectedFlights.forEach((segmentArr, journeyIndex) => {
      const isIncludedInFare = baggageService.journeys[journeyIndex] === "INC";

      if (!isIncludedInFare || !Array.isArray(segmentArr) || segmentArr.length === 0) {
        return;
      }

      const association = this.findJourneyAssociation(segmentArr, journeyIndex);
      if (!association) {
        return;
      }

      const selectedSegmentIds = segmentArr.map((s) => s.id).filter(Boolean);

      const matchingSegmentRefs = (association.segment_references || []).filter((segRef) =>
        selectedSegmentIds.includes(segRef?.id)
      );

      const baggageInfo = matchingSegmentRefs.find(
          (segRef) => segRef?.object?.baggage
        )?.object?.baggage;

        const weight = baggageInfo?.weight ?? "";
        const unit = baggageInfo?.unit ?? "";
        const quantity = baggageInfo?.quantity ?? null;

        let includedBaggageLabel = "Maleta incluida";

        if (weight) {
          includedBaggageLabel = `Maleta incluida en tarifa - ${weight}`;
        } else if (quantity != null && unit) {
          const normalizedUnit =
            String(unit).toLowerCase() === "units"
              ? quantity === 1
                ? "maleta"
                : "maletas"
              : unit;

          includedBaggageLabel = `Maleta incluida en tarifa: ${quantity} ${normalizedUnit}`;
        } else if (quantity != null) {
          includedBaggageLabel = `Maleta incluida en tarifa: ${quantity}`;
        }

      this.selectedUsers.forEach((_, passengerIndex) => {
                includedBags.push({
          id: `included-baggage-${journeyIndex}-${passengerIndex}`,
          category: "Baggage",
          currency: this.fareSelected?.currency?.iso || "EUR",
          distribution: "ByPassengerJourney",
          included: true,
          mandatory: false,
          fee: 0,
          price: 0,
          total: 0,
          selection: "one",
          short_name: includedBaggageLabel,
          journey_references: association.journey_references || [],
          seg_references: selectedSegmentIds,
          segment: selectedSegmentIds[0] || null,
          pax_index: [passengerIndex],
          pax_references: [String(passengerIndex)],
          source_i_d: `included-source-${journeyIndex}-${passengerIndex}`,
          value: `included-value-${journeyIndex}-${passengerIndex}`,
          extensions: weight ? { weight } : {},
          weight: weight || "",
        } as any);
      });
    });

    return includedBags;
  }

  private findJourneyAssociation(segmentArr: Segment[], journeyIndex: number): any {
    const selectedSegmentIds = segmentArr.map((s) => s.id).filter(Boolean);

    const byExactSegment = this.journeysAssociations.find((assoc) =>
      (assoc?.segment_references || []).some((segRef) =>
        selectedSegmentIds.includes(segRef?.id)
      )
    );

    if (byExactSegment) {
      return byExactSegment;
    }

    const fareJourneyId = this.fareSelected?.journeys_ids?.[journeyIndex];
    if (fareJourneyId) {
      const byJourneyRef = this.journeysAssociations.find((assoc) =>
        (assoc?.journey_references || []).includes(fareJourneyId)
      );
      if (byJourneyRef) {
        return byJourneyRef;
      }
    }

    return this.journeysAssociations[journeyIndex] || null;
  }

  private emitAllBaggages(): void {
    const manualBags = Array.isArray(this.selectedBags) ? this.selectedBags : [];
    const includedBags = Array.isArray(this.includedBaggages) ? this.includedBaggages : [];

    this.baggageSelectedEvent.emit([...manualBags, ...includedBags]);
  }

}
